import moment from 'moment';
import { useEffect, useRef } from 'react';
// import { QRCode } from "react-qr-code";
import { QRCodeCanvas } from 'qrcode.react';
import logo from '../img/logo.png';
import user from '../img/user.png';
import delivery from '../img/delivery.png';

const Item = ({
    checkIndex,
    courierPrefix,
    locationId,
    addressId,
    id,
    userName,
    userPhone,
    deliveryDay,
    timeStart,
    timeEnd,
    timezone,
    QrLink,
    kitchenName,
    products,
    orderPrice,
    prefixPoligon,
    translateX,
    onScaleCalculated,
}) => {
    const itemRef = useRef(null);

    function processProducts(products) {
        const result = [];
        const productMap = new Map();
      
        for (const product of products) {
          if (product.orderProductId === null) {
            // Это основной продукт
            product.modificator = null;
            result.push(product);
            productMap.set(product.id, product);
          } else {
            // Это модификатор
            const parentProduct = productMap.get(product.orderProductId);
            if (parentProduct) {
              parentProduct.modificator = product;
            }
          }
        }
      
        return result;
    }

    useEffect(() => {
        if (itemRef.current && onScaleCalculated) {
            const width = itemRef.current.offsetWidth;
            const colWidth = 415;
            const scale = Math.round(width / colWidth);
            onScaleCalculated(scale);
        }
    }, []);

    const modifiedProducts = processProducts(products);

    const currentTimezone = timezone || JSON.parse(localStorage.getItem('checklist'))?.timezone;

    return (
        <div 
            className="item-wrapper"
            ref={itemRef} 
            style={{ transform: translateX ? `translateX(${translateX})` : 'none' }}
        >
            <div className="item-header">
                <div className="item-header-title">
                    {courierPrefix ? 
                        <div className="item-courier">{courierPrefix}</div> : 
                        <div className="item-empty-courier"></div>
                    }
                    {locationId ? <div className="item-location">{locationId} -</div> : null}
                    {addressId ? <div className="item-address">{addressId}</div> : null}
                </div>
                <div className="item-header-description">
                    <div className="item-header-info">
                        <div className="item-header-info-item">
                            <div className="item-icon-wrapper">
                                №
                            </div>
                            {id}
                        </div>
                        {userName &&
                            <div className="item-header-info-item">
                                <div className="item-icon-wrapper">
                                    <img src={user} alt="user" width="16" height="16"/>
                                </div>
                                <div className="item-name">{userName}</div>
                            </div>
                        }
                        <div className="item-header-info-item">
                            <div className="item-icon-wrapper">
                                <img src={user} alt="user" width="16" height="16"/>
                            </div>
                            {userPhone}
                        </div>
                        <div className="item-header-info-item">
                            <div className="item-icon-wrapper">
                                <img src={delivery} alt="user" width="16" height="16"/>
                            </div>
                            {`${moment(deliveryDay).format('DD.MM')} • ${moment(timeStart, 'HH:mm').add(currentTimezone, 'hour').format('HH:mm')} - ${moment(timeEnd, 'HH:mm').add(currentTimezone, 'hour').format('HH:mm')}`}
                        </div>
                    </div>
                    <div className="item-header-qr-code">
                        <QRCodeCanvas value={QrLink} size={100}/>
                    </div>
                </div>
            </div>

            <div className="item-kitchen-name">{kitchenName}</div>
            {modifiedProducts
                .sort((a, b) => b.amount - a.amount)
                .map((item, index) => {
                    const isLastProduct = index === modifiedProducts.length - 1;
                    const shouldGroup = item.amount > 4;
                    const renderCount = shouldGroup ? 1 : item.amount;

                    return Array.from({ length: renderCount }).map((_, repeatIndex) => (
                        <div
                            style={isLastProduct && repeatIndex === renderCount - 1 ? {
                                display: 'flex',
                                flexDirection: 'column',
                                flex: '1',
                            } : {}}
                            key={`${index}-${repeatIndex}`}
                        >
                            <div className="item-product-item">
                                {shouldGroup ? 
                                    <div className="item-product-count" style={{ height: item.modificator && 'auto' }}>{item.amount}<span style={{ fontSize: '9px' }}>штук</span></div>
                                : null}

                                <div className="item-empty-product-count" style={{ height: item.modificator && 'auto' }}></div>
                                
                                {item.name ?
                                    <div className="item-product-name">
                                        {item.name ? 
                                            <div className="item-product">
                                                {item.modificator && <b>•</b>} 
                                                <div className="product-line">
                                                    <span className="product-name">{item.name}</span>
                                                    <span className="product-price">{+item.price}р</span>
                                                </div>
                                            </div> : null
                                        }
                                        {item.modificator && item.modificator.name ? (
                                            <div className="item-modificator">
                                                <b>•</b> 
                                                <div className="product-line">
                                                    <span className="product-name">{item.modificator.name}</span>
                                                    <span className="product-price">{+item.modificator.price}р</span>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                : null}
                            </div>
                            {isLastProduct && repeatIndex === renderCount - 1 && (
                                <>
                                    <div className="item-total-price">
                                        <div className="item-total-count-wrapper">
                                            <div className="item-empty-product-count">{modifiedProducts.reduce((sum, product) => sum + product.amount, 0)}</div>
                                                {Array.from({ length: Math.min(modifiedProducts.reduce((sum, product) => sum + product.amount, 0) - 1, 4) }).map((_, i) => (
                                                    <div key={i} className="item-product-count-layer"></div>
                                                ))}
                                        </div>
                                        Стоимость заказа: {+orderPrice} р
                                    </div>
                                    <div className="item-footer">
                                        <div className="item-sign">
                                            <div className="item-sign-logo">
                                                <img src={logo} alt="logo" width="100" height="20"/>
                                            </div>
                                            <div className="item-sign-phone">8-800-200-69-24</div>
                                        </div>
                                        <div className="item-index">{checkIndex + 1}</div>
                                        <div className="item-store">{prefixPoligon}</div>
                                    </div>
                                </>
                            )}
                        </div>
                    ));
                })
            }
        </div>
    );
};
            
export default Item;
